import {LitElement, html, CSSResult, unsafeCSS} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { consume } from '@lit/context';

import {Article, Messages} from "../../@types/online-reservation.js";
import { i18nContext } from "./i18nContext.js";
import {addPresentationToIcon} from "../icon/icon-accessibility.js";
import infoIcon
  from '@breuni-ui/nui/dist/design-tokens/images/icons/nui-faq_info_size=18.svg';
import styles from './online-reservation.scss';

@customElement('step-one')
export class StepOne extends LitElement {

  @consume({context: i18nContext})
  private messages!: Messages;

  @property({type: Object, reflect: false})
  private article!: Article;

  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  @property({ type: Function }) onNext!: () => void;

  render() {
    return html`
      <div class="ents-or__product-section">
        <section class="ents-or__image">
          <img src=${this.article.image.src} alt=${this.article.image.alt} />
        </section>
        <header class="ents-or__header">
          <span class="ents-or__header__brand ents-copy-small-bold">${this.article.brand}</span>
          <p class="ents-or__header__name ents-copy-small" title="${this.article.name}">${this.article.name}</p>
          ${this.article.color ? html`<p class="ents-or__header__description ents-copy-small"
          title="${this.messages['color']} ${this.article.color}">${this.messages['color']} ${this.article.color}</p>` : ''}
          <div class="ents-or__price ents-copy-small-bold ${this.article.price.priceReduced ? 'bewerten-shop-preis--rotpreis' : 'bewerten-shop-preis'}">${this.article.price.value}</div>
        </header>
      </div>

      <div class="ents-or__reservation-section">
        <h2 class="ents-or__reservation-header ents-heading-medium">${this.messages['reservationHeader']}</h2>
        <ul class="ents-or__benefits">
          <li class="ents-or__benefits__item">
            <ents-tooltip tooltip-namespace="ents:or" tooltip-placement="bottom">
              <div slot="trigger">
                <div class="ents-or__benefits__item__content">
                  <strong class="ents-copy-bold">${this.messages['points_quick_label']}</strong><span
                  class="ents-copy">${this.messages['points_quick_description']}</span>
                  <span class="ents-or__benefits__info-button" aria-label="Mehr Informationen">
                    ${addPresentationToIcon(infoIcon())}
                  </span>
                </div>
              </div>
              <div slot="content">
                <span class="ents-copy-small"> ${this.messages['tooltip']} </span>
              </div>
            </ents-tooltip>
          </li>
          <li class="ents-or__benefits__item">
            <strong class="ents-copy-bold">${this.messages['points_free_label']}</strong>
            <span class="ents-copy">${this.messages['points_free_description']}</span>
          </li>
          <li class="ents-or__benefits__item">
            <strong class="ents-copy-bold">${this.messages['points_flexible_label']}</strong>
            <span class="ents-copy">${this.messages['points_flexible_description']}</span>
          </li>
        </ul>
        <button class="ents-or__select-size-button nui-button-primary" data-test-ents-or-next-button
                @click=${this.onNext}>${this.messages['sizeButton']}</button>
      </div>
    `;
  }
}
